import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UserService } from "../../services/user.service";
import { FileInfoComponent, EditFileInfo } from './file-info.component';
import { JoiFile } from 'globals/store/files.model';
import { openDialogGetResult } from './../../helpers/angular-helpers';
import { FileLinkComponent, FileType } from './file-link.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'file-handler',
    templateUrl: './file-handler.html',
    styleUrls: ['./file-handler.component.scss'],
    standalone: true,
    imports: [FileLinkComponent, CommonModule],
})
export class FileHandlerComponent<T extends { files?: any, id?: string }> implements OnInit {

    @Input() data: T;
    @Input() ctaLink = false
    @Output() dataChange: EventEmitter<JoiFile[]> = new EventEmitter();
    @Input() readfilesonly = false;
    @Input() id: string;
    @Input() type: FileType = 'File'
    @Input() namePlaceholder = 'Title'
    @Input() addText = 'ADD FILE LINK'
    @Input() hideByline = false
    @Input() showLink = true;
    @Input() showNoFilesMessage = false
    @Input() noFilesMessage = 'No files.'
    @Input() fileLimit: number

    constructor(
      private dialog: MatDialog,
      private user:UserService) { }

    ngOnInit() {
        if (!this.data.files) { this.data = {...this.data, files: []}; }
        if (!this.data.id && this.id) {
            this.data.id = this.id;
        } else if (!this.data.id) {
            this.data.id = 'Id';
        }
    }

    handleFileDialog(result, index = 0) {
      if (result) {
        let { action, item } = result
        console.log({ action, item, index })
        switch (action) {
          case 'delete':
            this.data.files.splice(index, 1);
            this.dataChange.emit(this.data.files);
            break
          case 'create':
            this.data.files.push(item)
            index = this.data.files.length - 1
            break
          case 'update':
            const updatedFile: JoiFile = { ...item, modified: (new Date()).getTime(), by: this.user.displayName, by_uid: this.user.uid }
            // console.log({ updatedFile })
            this.data.files[index] = updatedFile
            break
          default:
            return console.log("Something wrong in handleFileDialog!", { action, item, index })
        }
        this.emitLinkChange(index)

      }
    }

    openFileDialog(event, file = null, index?: number) {
      const { x, y } = event.target.getBoundingClientRect();
      const data: EditFileInfo = { type: this.type, item: (file ? file : this.getFreshFile()), x, y, index, new: index === null, namePlaceholder: this.namePlaceholder, putOnTop: !!window['fromFlutter'] };
      console.log({ event, file, index, data })
      openDialogGetResult(this.dialog, FileInfoComponent, { width: '300px', disableClose: true, data, backdropClass: 'clear' }).then(result => 
        this.handleFileDialog(result, index)
      )
    }

    getFreshFile(): JoiFile{
      return {
        filename:'',
        by: this.user.displayName,
        by_uid:this.user.uid,
        linkUrl:'',
        created: (new Date()).getTime(),
      }
    }

    emitLinkChange(idx){
      if(this.data.files[idx]){
          this.dataChange.emit(this.data.files);
      }
    }


}
